export default __webpack_public_path__ + "static/media/error-modal-banner.e2fdcd7e.png";